import { render, staticRenderFns } from "./EditSimpleVenueLoader.vue?vue&type=template&id=2679c138"
import script from "./EditSimpleVenueLoader.vue?vue&type=script&lang=ts"
export * from "./EditSimpleVenueLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports